export const TAXONOMY_DATA_REQUEST = "TAXONOMY_DATA_REQUEST";
export const TAXONOMY_DATA_RECEIVE = "TAXONOMY_DATA_RECEIVE";
export const TAXONOMY_DATA_FAILURE = "TAXONOMY_DATA_FAILURE";
export const RESET_TAXONOMY_DATA = "RESET_TAXONOMY_DATA";
